module.exports = __webpack_public_path__ + "img/plus.30588d4f.svg";